import { StorageService } from '../../services/storage.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, LoadingController, AlertController, IonTextarea } from '@ionic/angular';
import { CartService } from '../../services/cart.service';
import { ParkedCartService } from '../../services/parked-cart.service';
import { ConnectedAccountService } from '../../services/connected-account.service';

@Component({
    selector: 'app-cart-park',
    templateUrl: './cart-park.page.html',
    styleUrls: ['./cart-park.page.scss'],
})

export class CartParkPage implements OnInit {

    @ViewChild('special_instructions_input', { static: false }) special_instructions_input: IonTextarea;

    spinner = null;
    special_instructions = "";
    customer_note = "";
    internal_note = "";
    parked_cart = {
        date: null,
        user_id: null,
        cart: {}
    };

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private storageService: StorageService,
        private cartService: CartService,
        private parkedCartService: ParkedCartService,
        private connectedAccountService: ConnectedAccountService
    ) { }

    ngOnInit() {

        this.cartService.get().then((cart: any) => {

            if(cart) {
                this.parked_cart.cart = cart;
                if(cart.special_instructions) {
                    this.special_instructions = cart.special_instructions;
                }
                if(cart.customer_note) {
                    this.customer_note = cart.customer_note;
                }
                if(cart.internal_note) {
                    this.internal_note = cart.internal_note;
                }
            }

            if(cart['parked_cart_id']) {
                this.parkedCartService.getParkedCart(cart['parked_cart_id']).then((parked_cart: any) => {
                    if(parked_cart.cart.special_instructions) {
                        this.special_instructions = parked_cart.cart.special_instructions;
                    }
                    if(parked_cart.cart.customer_note) {
                        this.customer_note = parked_cart.cart.customer_note;
                    }
                    if(parked_cart.cart.internal_note) {
                        this.internal_note = parked_cart.cart.internal_note;
                    }
                })
                .catch(() => {});
            }

        });

        this.storageService.get("connected_account_id").then((connected_account_id) => {
            if (connected_account_id) {
                this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account: any) => {
                    if(connected_account) {
                        this.parked_cart.user_id = connected_account.user_id;
                    }
                });
            }
        });

        this.parked_cart.date = new Date().toISOString();
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.special_instructions_input) {
                this.special_instructions_input.setFocus();
            }
        }, 200);
    }

    close() {
        this.modalController.dismiss();
    }

    park() {

        if (this.special_instructions == null || this.special_instructions.trim() === "") {
            this.parked_cart.cart['special_instructions'] = "";
        } 
        else {
            this.parked_cart.cart['special_instructions'] = this.special_instructions;
        }

        if (this.customer_note == null || this.customer_note.trim() === "") {
            this.parked_cart.cart['customer_note'] = "";
        } 
        else {
            this.parked_cart.cart['customer_note'] = this.customer_note;
        }

        if (this.internal_note == null || this.internal_note.trim() === "") {
            this.parked_cart.cart['internal_note'] = "";
        } 
        else {
            this.parked_cart.cart['internal_note'] = this.internal_note;
        }

        if (this.parked_cart.cart['parked_cart_id']) {
            this.presentSpinner("Updating parked cart").then(() => {
                this.parkedCartService.updateParkedCart(this.parked_cart).then(() => {
                    this.cartService.reset().then(async () => {
                        await this.spinner.dismiss();
                        await this.modalController.dismiss();
                    });
                });
            })
            .catch(() => {
                this.spinner.dismiss();
            });
        } 
        else {
            this.presentSpinner("Parking cart").then(() => {
                this.parkedCartService.addParkedCart(this.parked_cart).then(() => {
                    this.cartService.reset().then(async () => {
                        await this.spinner.dismiss();
                        await this.modalController.dismiss();
                    });
                });
            })
            .catch(() => {
                this.spinner.dismiss();
            });
        }
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
